import { Typography, useTheme } from "@mui/material";
import "./TextMitBild.css";

export function TextMitBildLinks(props: {
  bild: "*.jpg";
  alt: string;
  children: React.ReactNode[];
}) {
  return (
    <div className="text-mit-bild text-mit-bild-links">
      <Text>{props.children}</Text>
      <Spacing />
      <Bild src={props.bild} alt={props.alt} />
    </div>
  );
}

export function TextMitCustomBildLinks(props: {
  bild: "*.png";
  alt: string;
  children: React.ReactNode[];
}) {
  return (
    <div className="text-mit-bild text-mit-bild-links">
      <Text>{props.children}</Text>
      <Spacing />
      <img
        src={props.bild}
        alt={props.alt}
        className="custom-bild"
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}

export function TextMitBildRechts(props: {
  bild: "*.jpg";
  alt: string;
  children: React.ReactNode[];
}) {
  return (
    <div className="text-mit-bild text-mit-bild-rechts">
      <Text>{props.children}</Text>
      <Spacing />
      <Bild src={props.bild} alt={props.alt} />
    </div>
  );
}

export function TextMitCustomBildRechts(props: {
  bild: "*.png";
  alt: string;
  children: React.ReactNode[];
}) {
  return (
    <div className="text-mit-bild text-mit-bild-rechts">
      <Text>{props.children}</Text>
      <Spacing />
      <img
        src={props.bild}
        alt={props.alt}
        className="custom-bild"
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}

function Spacing() {
  return <div className="text-mit-bild-spacing" />;
}

function Text(props: { children: React.ReactNode[] }) {
  return <div className="text">{props.children}</div>;
}

function Bild(props: { src: "*.jpg"; alt: string }) {
  return (
    <div>
      <div className="bild">
        <div />
        {/* .bild img already gets aspect-ratio: 2/3 from CSS, so CLS is
            handled. loading="lazy" defers off-screen service-page photos. */}
        <img
          src={props.src}
          alt={props.alt}
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>
  );
}

export function Headline(props: { children: string; level?: "h1" | "h2" }) {
  const theme = useTheme();
  return (
    <>
      <Typography
        className="headline"
        variant="h1"
        component={props.level ?? "h2"}
        fontSize="48px"
        align="center"
        color={theme.palette.secondary.contrastText}
      >
        {props.children.replace("\\n", "\r\n")}
      </Typography>
      <HR />
    </>
  );
}

function HR() {
  const theme = useTheme();
  return (
    <div
      style={{
        margin: "12px 15% 24px 15%",
        height: "2px",
        backgroundColor: theme.palette.primary.main,
      }}
    />
  );
}
